import { request } from './client';

/**
 * Auth-service surface (AyushSetuAuthService).
 *
 * Lives at a different base than the ABDM Connector: env var
 * `VITE_AUTH_BASE_URL` overrides; default falls back to a same-origin
 * relative URL so a reverse proxy can route `/auth/*` to the auth
 * service and `/api/*` + `/admin/*` to AbdmConnector.
 *
 * The shape of the responses matches AUTH-2's controller; if you flip
 * `MODE` in LoginPage from 'token' to 'credentials', this module
 * powers the form.
 */

const AUTH_BASE = (import.meta.env['VITE_AUTH_BASE_URL'] as string | undefined)?.replace(/\/$/, '') ?? '';

function url(path: string): string {
  return AUTH_BASE ? `${AUTH_BASE}${path}` : path;
}

export interface TokenPair {
  accessToken: string;
  accessExpiresAt: string;
  refreshToken: string;
  refreshExpiresAt: string;
}

export interface MeResponse {
  id: string;
  email: string;
  name: string | null;
  role: string;
  tenantId: string | null;
  enabled: boolean;
  lastLoginAt: string | null;
}

export const auth = {
  login:    (body: { email: string; password: string }) =>
    request<TokenPair>({ url: url('/auth/login'), method: 'POST', data: body }),

  refresh:  (refreshToken: string) =>
    request<TokenPair>({ url: url('/auth/refresh'), method: 'POST', data: { refreshToken } }),

  logout:   (refreshToken: string | null) =>
    request<void>({ url: url('/auth/logout'), method: 'POST', data: refreshToken ? { refreshToken } : {} }),

  logoutAll: () =>
    request<void>({ url: url('/auth/logout-all'), method: 'POST' }),

  me:       () =>
    request<MeResponse>({ url: url('/auth/me'), method: 'GET' }),
};
